import { useTranslation } from 'react-i18next';
import { tableRefreshReasonTypes as refreshReasons } from 'shared/constants/tableRefreshReasonTypes';
import { ItemType, PortfolioItem, SelectedEntities } from 'shared/types/portfolios';
import {
  useAddToPortfolio,
  useCopyPortfolioItems,
  useCopyAllPortfolioItems,
  useMovePortfolioItems,
  useMoveAllPortfolioItems,
} from '../GraphQL/portfolios/hooks';

export const useVariantAction = (
  itemsData: SelectedEntities,
  itemType: PortfolioItem,
  sourcePortfolioId: string,
) => {
  const { t } = useTranslation();
  const addToPortfolio = useAddToPortfolio(itemType);
  const copyPortfolioItems = useCopyPortfolioItems(itemType);
  const copyAllPortfolioItems = useCopyAllPortfolioItems(itemType);
  const movePortfolioItems = useMovePortfolioItems(itemType);
  const moveAllPortfolioItems = useMoveAllPortfolioItems(itemType);

  const result = {
    add: {
      title: t('TOOLBAR.ADD_TO_PORTFOLIO'),
      submit: t('ADD'),
      itemSubmitSuccess: t('PORTFOLIO.ITEMS_ADDED_TO_NEW_PORTFOLIO'),
      refreshSettings: { refresh: true, reason: refreshReasons.ADDED },
      action: (portfolioId: string) =>
        addToPortfolio({
          portfolioId,
          artifactIdList: Object.values(itemsData.itemIds || itemsData.items).map(id => ({
            value: id,
            type: itemsData.type ?? ItemType.UNKNOWN,
          })),
        }),
    },
    copy: {
      title: t('TOOLBAR.COPY_TO_PORTFOLIO'),
      submit: t('COPY'),
      itemSubmitSuccess: t('PORTFOLIO.ITEMS_COPIED_TO_NEW_PORTFOLIO'),
      refreshSettings: { refresh: false, reason: '' },
      action: (portfolioId: string) =>
        copyPortfolioItems({
          portfolioId,
          itemIds: Object.values(itemsData.itemIds),
          sourcePortfolioId,
        }),
    },
    copy_all: {
      title: t('TOOLBAR.COPY_TO_PORTFOLIO'),
      submit: t('COPY'),
      itemSubmitSuccess: t('PORTFOLIO.ITEMS_COPIED_TO_NEW_PORTFOLIO'),
      refreshSettings: { refresh: false, reason: '' },
      action: (portfolioId: string) =>
        copyAllPortfolioItems({
          portfolioId,
          sourcePortfolioId,
        }),
    },
    move: {
      title: t('TOOLBAR.MOVE_TO_PORTFOLIO'),
      submit: t('MOVE'),
      itemSubmitSuccess: t('PORTFOLIO.ITEMS_MOVED_TO_NEW_PORTFOLIO'),
      refreshSettings: { refresh: true, reason: refreshReasons.MOVED },
      action: (portfolioId: string) =>
        movePortfolioItems({
          destinationPortfolioId: portfolioId,
          itemIds: Object.values(itemsData.itemIds),
          sourcePortfolioId,
        }),
    },
    move_all: {
      title: t('TOOLBAR.MOVE_TO_PORTFOLIO'),
      submit: t('MOVE'),
      itemSubmitSuccess: t('PORTFOLIO.ITEMS_MOVED_TO_NEW_PORTFOLIO'),
      refreshSettings: { refresh: true, reason: refreshReasons.MOVED },
      action: (portfolioId: string) =>
        moveAllPortfolioItems({
          destinationPortfolioId: portfolioId,
          sourcePortfolioId,
        }),
    },
  };
  return result;
};
